<template>
  <div v-html="remark">
  </div>
</template>
<script>
    export default {
        methods:{
            getNoticeByChannelId:function (channelId) {
                this.$axiosService.post('setNotice/getNoticeByChannelId', {channelId:channelId}, response => {
                    if (response.code==0) {
                        this.remark=response.data==null?'':response.data.remark
                    }
                });
            },
        },
        computed:{
          routerQuery() {
            return this.$route.query;
          },
        },
        watch: {
            routerQuery: {
                handler(curVal, oldVal) {
                    this.getNoticeByChannelId(curVal.channelId);
                },
                deep: true,
                immediate:true,
            },
        },
        data() {
            return {
                remark:"",
                channelId:33
            }
        },
    }
</script>
